import { v4 as uuidv4 } from 'uuid';

const COOKIE_KEY = 'split_anonymous_id';

const setCookie = (name: string, value: string, days: number) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  const domain = `domain=${window.location?.hostname}`;
  document.cookie = `${name}=${value};${expires};path=/;${domain}`;
};

const getCookie = (name: string): string | null => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';').map((cookie) => cookie.trim());

  for (const cookie of cookies) {
    if (cookie.startsWith(nameEQ)) {
      return cookie.substring(nameEQ.length);
    }
  }

  return null;
};

export const getSplitIOKey = () => {
  let userKey = getCookie(COOKIE_KEY);

  if (!userKey) {
    userKey = uuidv4();
    setCookie(COOKIE_KEY, userKey, 365);
  }
  return userKey;
};
